const Resources = {

    breadcrumb:[
        {
            name: 'Home',
            href: '/',
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: 'Buildings',
            href: '/buildings',
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: 'Areas',
            href: '/building-areas',
            arrow: "",
        },
    ],

    table_headers: [
        { 
            text: 'Building Name',
            value: 'building_name',
            sort_type: 'text',
        },
        {
            text: 'Level Name',
            value: 'level_name',
            sort_type: 'text',
        },
        { 
            text: 'Name',
            align: 'start', 
            value: 'name',
            type: 'link',
            sort_type: 'text',
        },
        { 
            text: 'Abbreviation',
            value: 'abbreviation',
            sort_type: 'text',
        },
        { 
            text: 'Frequency',
            value: 'frequency',
            sort_type: 'number',
        },
        {
            text: 'Room Counter',
            value: 'room_counter',
            type: 'text_link_action',
            sort_type: 'number'
        },
        {
            text: 'Sq. Footage',
            value: 'sq_footage',
            sort_type: 'number',
        },
    ],
    
    excel_file_headers: {
        'Building': 'building_id',
        'Level': 'level_id',
        'Name': 'name',
        'Abbreviation': 'abbreviation',
        'Frequency': 'frequency',
        'Closed': 'closed',
        'Daily shift #1': 'daily_shift_1',
        'Daily shift #2': 'daily_shift_2',
        'Daily shift #3': 'daily_shift_3',
        'Policing shift #1': 'policing_shift_1',
        'Policing shift #2': 'policing_shift_2',
        'Policing shift #3': 'policing_shift_3',
        'Project shift #1': 'project_shift_1',
        'Project shift #2': 'project_shift_2',
        'Project shift #3': 'project_shift_3',
    },

    empty_format_data: [
        {
            building_id:        '',
            level_id:           '',
            name:               '',
            abbreviation:       '',
            frequency:          0,
            closed:             false,
            daily_shift_1:      false,
            daily_shift_2:      false,
            daily_shift_3:      false,
            policing_shift_1:   false,
            policing_shift_2:   false,
            policing_shift_3:   false,
            project_shift_1:    false,
            project_shift_2:    false,
            project_shift_3:    false,
        },
    ],

    helps: [
        {
            label: '¿How to add an Area?', 
            instruction: `https://scribehow.com/embed/Add_an_Area__ygvJsJmSRMCNYJOcXTiMzw?as=scrollable`
        },
        {
            label: '¿How to delete Areas?', 
            instruction: `https://scribehow.com/embed/How_To_Delete_Areas__owDQ-7XMSKudpRA_nGCJZQ?as=scrollable`
        },
    ]

}

export default Resources;